module.exports = __webpack_public_path__ + "static/media/3.b00c407b.png";